var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ImageSelection", {
    attrs: {
      "form-id": _vm.formId,
      "column-name": _vm.field.name,
      "file-id": _vm.fileId,
      "on-change": _vm.onChange,
      readonly: _vm.field.readonly,
      "remove-option": true,
      "row-id": _vm.currentData.id,
      "table-name": _vm.tableName,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }